import React from "react";
import MuiAlert from "@material-ui/lab/Alert";

function Alert(props) {
    return <MuiAlert elevation={6}
                     variant="filled" {...props}
                     style={
                         {
                             'background-color': '#35abf8',
                             'color': '#fff9f9',
                             'font-style': 'normal'
                         }
                     }
    />;
}

export default Alert;